// components/ModalAddEvent.jsx
import { useState } from "react";
import Swal from "sweetalert2";

export default function ModalAddPic({ isOpen, onClose, onAdded }) {
  const [picName, setPicName] = useState("");
  const [picUsername, setPicUsername] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!picName.trim()) return;

    const data = {
      name: picName,
      username: picUsername
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/pic/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Gagal menyimpan event");
      }

      const resData = await response.json();

      if (resData && resData.id) {
        onAdded(resData); 
      }
        Swal.fire('Berhasil', 'PIC berhasil ditambahkan.', 'success');
        setPicName("");
        setPicUsername("");
        onClose();
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl shadow-2-xl w-96">
        <h2 className="text-lg font-semibold mb-4">Tambah PIC </h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="w-full border p-2 rounded-2xl mb-4"
            placeholder="Nama PIC"
            value={picName}
            onChange={(e) => setPicName(e.target.value)}
          />
          <input
            type="email"
            className="w-full border p-2 rounded-2xl mb-4"
            placeholder="Email"
            value={picUsername}
            onChange={(e) => setPicUsername(e.target.value)}
          />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition">Batal</button>
            <button type="submit" className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition">
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
